import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { AfficheReservationMensuel } from '../../Api/RestaurantApi/ResaMensuelApi';
import './css/resaJournalier.css';

const ResaJournalier = () => {

  const [data, setData] = useState();
  const [event, setEvent] = useState([]);
  const [loading, setLoading] = useState(false);


  const restaurant = useSelector((state) => state.restaurant);

  let location = useLocation();
  const { state } = useLocation();
  let navigate = useNavigate();
  // const { title, donner } = state;


  function renderEventContent(eventInfo) {
    if (eventInfo.event.title === "reservation") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor, display: 'flex' }}>
          <div>Résa <i> {eventInfo.event.extendedProps.resa}</i></div>-
          <div className=''>Couv <i> {eventInfo.event.extendedProps.couverte}</i></div>
        </div>
      )
    } else if (eventInfo.event.title === "fermeture") {
      return (
        <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor }}>
          <div><i> {eventInfo.event.title}</i></div>
        </div>
      )
    }
    // } else if (eventInfo.event.title === "Fermeture P.") {
    //     return (
    //         <div style={{ backgroundColor: eventInfo.event.backgroundColor, color: eventInfo.event.textColor}}>
    //             <div><i> {eventInfo.event.title}</i></div>
    //         </div>
    //     )
    // }

  }




  const formatSingle = (date) => {
    if (parseInt(date) < 10) {
      return "0" + date;
    } else {
      return date;
    }
  }

  useEffect(() => {
    AfficheResaResto();
  }, []);

  const AfficheResaResto = () => {
    setLoading(true);
    AfficheReservationMensuel(restaurant.id)
      .then(function (response) {
        console.log("data =>", response.data.donner);
        response.data.donner.forEach((element) => {
          let date = new Date(element.datePrise).getFullYear() + "-" + formatSingle(parseInt(new Date(element.datePrise).getMonth() + 1)) + "-" + formatSingle(new Date(element.datePrise).getDate()) + "T" + formatSingle(new Date(element.heurePrise).getUTCHours()) + ":" + formatSingle(new Date(element.heurePrise).getMinutes()) + ":" + "00";
          let TotalRes = response.data.donner.filter((el) => el.datePrise === element.datePrise);
          let TotalPersonne = TotalRes.reduce((prev, current) => prev + parseInt(current.nombrePersonne), 0);

          const existeDate = event.find((el) => el.start === date);
          if (existeDate) {
            console.log("Modification");
          } else {
            setEvent((prev) => [...prev, { title: 'reservation', start: date, resa: TotalRes.length, couverte: TotalPersonne, backgroundColor: 'blue', textColor: '#fff', display: 'background' }]);
          }
        });

        restaurant.fermetureCongers.forEach((item) => {
          setEvent((prev) => [...prev, { title: 'fermeture', start: new Date(item.du).getFullYear() + "-" + formatSingle(parseInt(new Date(item.du).getMonth() + 1)) + "-" + formatSingle(new Date(item.du).getDate()), end: new Date(item.au).getFullYear() + "-" + formatSingle(parseInt(new Date(item.au).getMonth() + 1)) + "-" + formatSingle(parseInt(new Date(item.au).getDate() + 1)), backgroundColor: 'grey', textColor: '#fff', display: 'background' }])
        });
        setData(response.data.donner);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoading(false);
      });
  };

  console.log("Les event sont =>", event);




  return (
    <div>
      <Helmet>
        <title>Reservation Journalier</title>
        <meta name='description' content='Restaurant réservation journalier .' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='journalier'>
        <div className='container'>
          <div className='bloc_journalier'>
            <div className='journalier_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-calendar-o'></i> <h1>Etats de réservations – vision journalier</h1>
                {/* {title !== ""? title :''} */}
              </div>
              <div className='journalier_renseignement'>
                <p>Affichage de la répartition des réservations de la journée, prenant en compte les créneaux de fermeture, vous permettant de visualiser rapidement votre activité et d’ajuster vos promotions, organisation et prises de réservation en direct.
                </p>
                <p><span className='avertissement'>Attention : </span> il s’agit des créneaux  de réservation (début de la prestation) et non du temps de présence de vos clients à table !
                </p>
              </div>
            </div>
            <div className='journalier_content'>
              <div className='d-flex justify-content-center'>
                <div className='calendar'>
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin]}
                    initialView="timeGridDay"
                    height='1350px'
                    allDayText='Heure'
                    buttonText={{
                      today: "Aujourd'hui",
                    }}

                    slotLabelInterval='00:30:00'
                    slotMinTime='01:00:00'
                    slotMaxTime='24:00:00'
                    slotLabelFormat={[
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                        meridiem: false
                      },
                    ]}

                    eventContent={renderEventContent}
                    headerToolbar={{
                      left: 'prev,next',
                      center: 'title',
                      right: 'today'
                    }}
                    events={event}
                    // eventClick={(info) => {
                    //   if (info.event.title === "reservation") {
                    //     setData(info.event);
                    //     navigate('/restaurant/creneau', { state: { title: info.event.title, donner: info.event.extendedProps } });
                    //   }

                    // }}
                    // eventMouseEnter = {(info) => {
                    //   alert(info.event.title);
                    // } }
                    locale='fr'
                  />

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default ResaJournalier